/* eslint-disable no-console */
class LoggerUtil {
  static trace (msg) {
    if (this.canLogMessage(this.LogLevels.TRACE)) {
      console.log(msg)
    }
  }

  static debug (msg) {
    if (this.canLogMessage(this.LogLevels.DEBUG)) {
      console.log(msg)
    }
  }

  static info (msg) {
    if (this.canLogMessage(this.LogLevels.INFO)) {
      console.log(msg)
    }
  }

  static warn (msg) {
    if (this.canLogMessage(this.LogLevels.WARN)) {
      console.log(msg)
    }
  }

  static error (msg) {
    if (this.canLogMessage(this.LogLevels.ERROR)) {
      console.log(msg)
    }
  }

  static canLogMessage (level) {
    return (process.env.VUE_APP_LogLevel === undefined ? 1 : parseInt(process.env.VUE_APP_LogLevel)) <= level
  }
}
/* eslint-enable no-console */

LoggerUtil.LogLevels = Object.freeze({
  TRACE: 0,
  DEBUG: 1,
  INFO: 2,
  WARN: 3,
  ERROR: 4
})

export default LoggerUtil
